// IMPORTS
// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { Environment } from "relay-runtime";
import { createTeamSubscriptionStripeMutation } from "./CreateTeamSubscriptionStripe.gql";

// TYPES
interface ICreateTeamSubscriptionStripeMutationResponse {
  createTeamSubscriptionStripe: ISchema.ICreateTeamSubscriptionStripePayload;
}

// MUTATION
export function createTeamSubscriptionStripe(
  environment: Environment,
  input: ISchema.ICreateTeamSubscriptionStripeInput,
  onSuccess: (response?: ISchema.ICreateTeamSubscriptionStripePayload) => void,
  onError: (error?: any) => void,
) {
  commitMutation(environment, {
    onError,
    mutation: createTeamSubscriptionStripeMutation,
    variables: { input },
    updater: (store, data: any) => {
      const { team } = data.createTeamSubscriptionStripe;

      // get the org from store
      const orgProxy = store.get(input.orgRelayId);
      if (!orgProxy) {
        return;
      }

      // get the userTeams from the store org
      const userTeamsProxy = orgProxy.getLinkedRecord("userTeams");
      if (!userTeamsProxy) {
        return;
      }

      // get the list from the store userTeams
      const userTeamsListProxy = userTeamsProxy.getLinkedRecords("list");

      if (userTeamsListProxy && userTeamsListProxy.length) {
        // find the team from store and add to userTeams
        const newTeam = store.get(team.id) || null;

        // remove the team with corresponding team id and add in new team
        userTeamsProxy.setLinkedRecords(
          [
            ...userTeamsListProxy
              .filter((ut) => ut && ut.getDataID() !== team.id)
              .map((aip) => aip),
            newTeam,
          ],
          "list",
        );
      }
    },
    onCompleted: (response: ICreateTeamSubscriptionStripeMutationResponse, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        onSuccess(response.createTeamSubscriptionStripe);
      }
    },
  });
}
